import axios from "axios";
import { dashboardAction } from "../actionTypes";
import { url } from "../../config/config";

export const dashboardInitiate = () => ({ type: dashboardAction.DASHBOARD_INITIATE })
export const dashboardSuccess = (data) => ({ type: dashboardAction.DASHBOARD_SUCCESS, payload: data })
export const dashboardFailure = () => ({ type: dashboardAction.DASHBOARD_FAILURE })

export function getDashboard() {
    return async dispatch => {
        dispatch(dashboardInitiate())
        try {
            const { data } = await axios.get(`${url}dashboard`)
            dispatch(dashboardSuccess(data))
            return data
        } catch (err) {
            dispatch(dashboardFailure())
            throw err
        }
    }
}
